var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRandomwalkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 34,
    viewBox: "0 0 147 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3582_703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.17285 10.5995C1.17292 10.0598 1.34907 9.5352 1.67401 9.10693C1.99895 8.67866 2.45455 8.37064 2.97024 8.23056C3.48592 8.09049 4.03293 8.12618 4.52651 8.33211C5.0201 8.53804 5.43273 8.90272 5.70048 9.36966H12.4956V11.8304H5.70048C5.43268 12.2974 5.01996 12.6621 4.52627 12.868C4.03258 13.0739 3.48548 13.1095 2.96973 12.9693C2.45398 12.8291 1.99839 12.5209 1.67353 12.0925C1.34867 11.664 1.17269 11.1393 1.17285 10.5995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4929 31.5474C16.4927 31.1174 16.6045 30.6949 16.817 30.3223C17.0295 29.9497 17.3352 29.6402 17.7035 29.4248V27.84H11.1175V5.38815C10.5443 5.10991 10.0816 4.64313 9.8052 4.06431C9.52884 3.4855 9.45522 2.82897 9.59639 2.20232C9.73757 1.57568 10.0852 1.01608 10.5822 0.615241C11.0793 0.214401 11.6963 -0.00390625 12.3322 -0.00390625C12.9681 -0.00390625 13.5852 0.214401 14.0822 0.615241C14.5793 1.01608 14.9269 1.57568 15.0681 2.20232C15.2092 2.82897 15.1356 3.4855 14.8593 4.06431C14.5829 4.64313 14.1202 5.10991 13.547 5.38815V25.3761H20.133V29.4248C20.5016 29.6406 20.8075 29.9507 21.02 30.3238C21.2324 30.6969 21.3441 31.1199 21.3436 31.5504C21.3431 31.9809 21.2305 32.4037 21.0172 32.7763C20.8039 33.1489 20.4973 33.4583 20.1282 33.6732C19.7592 33.8882 19.3406 34.0012 18.9147 34.001C18.4887 34.0007 18.0703 33.8871 17.7015 33.6717C17.3327 33.4563 17.0265 33.1466 16.8136 32.7738C16.6008 32.4009 16.4887 31.9779 16.4887 31.5474H16.4929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.536 15.3023L136.814 13.561L143.558 6.74414H147L139.219 14.6134L138.657 13.9953V15.1797L138.536 15.3023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.697 18.7065H143.256L136.512 11.8886L138.233 10.1484L138.652 10.5711V11.7438L139.23 11.1501L146.696 18.7065H146.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.73 18.7023H122.066L118.1 9.7025L114.134 18.7023H111.47L116.737 6.74414H119.462L124.73 18.7023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.031 14.7839V12.3242H114.598V14.7839H122.031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.095 17.003V16.984H125.875V5.04492H128.309V14.5434H134.895V17.003H126.095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.657 6.74414H136.224V18.7023H138.657V6.74414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4648 13.0176H95.8985V18.7029H93.4648V13.0176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.915 6.86914H107.481V18.7026H109.915V6.86914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0098 17.1255L95.8701 18.7031L103.28 9.77821L101.42 8.20056L94.0098 17.1255Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.96 8.1997L100.1 9.77734L107.509 18.7023L109.37 17.1246L101.96 8.1997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.733 7.81836L103.373 9.90295H100.117L101.733 7.81836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1357 18.6812H37.6445V16.2173H40.1357V4.74414H42.5705V4.75048L49.2913 12.8458V4.74414H51.725V16.7023H49.2945V16.66L42.5705 8.56148V18.6812H40.1357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08626e-06 19.608C7.29097e-05 19.0683 0.176219 18.5437 0.501159 18.1155C0.826099 17.6872 1.2817 17.3792 1.79739 17.2391C2.31308 17.099 2.86008 17.1347 3.35366 17.3406C3.84725 17.5466 4.25988 17.9113 4.52763 18.3782H17.5345V0.458985H22.4594V2.91865H19.9671V9.03717H22.4583V9.04351C23.2624 9.04351 24.0335 8.7207 24.602 8.14608C25.1706 7.57147 25.49 6.79212 25.49 5.9795C25.49 5.16687 25.1706 4.38752 24.602 3.81291C24.0335 3.2383 23.2624 2.91548 22.4583 2.91548L22.4594 0.458985C23.768 0.458163 25.0323 0.93226 26.0241 1.79498C27.016 2.6577 27.6683 3.85168 27.8625 5.1596C28.0566 6.46752 27.7796 7.80241 27.0819 8.92129C26.3842 10.0402 25.3122 10.8687 24.0609 11.2559L28.9304 17.1219L27.0654 18.7068L21.0826 11.5011H19.9671V20.8421H4.52763C4.2597 21.3093 3.8467 21.6742 3.3527 21.88C2.85869 22.0859 2.31128 22.1213 1.79537 21.9806C1.27945 21.84 0.823857 21.5313 0.499248 21.1023C0.174638 20.6733 -0.000848704 20.1481 3.08626e-06 19.608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2706 18.6788H37.6069L33.6407 9.67906L29.6755 18.6788H27.0107L32.2785 6.7207H35.0028L40.2706 18.6788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1162 14.7604V12.3008H30.1382V14.7604H37.1162Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5297 18.7008H54.0961V9.18232H51.1543V6.72266H56.5297V6.73533H60.0109V6.72266C60.1447 6.72266 60.2775 6.72688 60.4092 6.73533H60.4657C61.9521 6.84992 63.3408 7.52796 64.3536 8.6336C65.3663 9.73923 65.9283 11.1908 65.9268 12.6975C65.9274 13.4828 65.7748 14.2606 65.4776 14.9862C65.1805 15.7119 64.7448 16.3712 64.1953 16.9266C63.6459 17.4819 62.9935 17.9223 62.2755 18.2225C61.5575 18.5228 60.788 18.6771 60.0109 18.6765V18.6977L56.5297 18.7008ZM56.5297 16.2401H60.0109V16.2042C60.4713 16.2123 60.9286 16.1276 61.3563 15.9551C61.7839 15.7827 62.1733 15.5259 62.5017 15.1997C62.8301 14.8735 63.0909 14.4845 63.269 14.0553C63.447 13.6262 63.5387 13.1655 63.5387 12.7001C63.5387 12.2348 63.447 11.7741 63.269 11.3449C63.0909 10.9158 62.8301 10.5268 62.5017 10.2006C62.1733 9.8744 61.7839 9.61758 61.3563 9.44511C60.9286 9.27264 60.4713 9.18798 60.0109 9.19606H56.5297V16.2401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9841 16.7032H66.791V5.39062H77.9841V16.7032ZM69.2111 7.83655V14.2573H75.564V7.83655H69.2111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8761 6.74414H79.4424V18.7023H81.8761V6.74414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8966 6.74414H93.4629V12.7232H95.8966V6.74414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6512 17.5369L80.001 8.32158L81.8618 6.74414L89.2381 15.6287L87.6512 17.5358V17.5369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6494 17.5316L86.0625 15.6192L93.4347 6.74414L95.2955 8.32158L87.6494 17.5316Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3582_703"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 147,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRandomwalkWhite);
export default __webpack_public_path__ + "static/media/randomwalk-white.8338b18b04927809c0780f247b6af2db.svg";
export { ForwardRef as ReactComponent };